var render = function render(){var _vm=this,_c=_vm._self._c;return _c('resource-lists-empty-state',{attrs:{"title":_vm.s__('GroupsEmptyState|No public or internal groups'),"svg-path":_vm.$options.groupsEmptyStateIllustration,"search":_vm.search}})
}
var staticRenderFns = []

export { render, staticRenderFns }